import React from 'react';
import { motion } from 'framer-motion';
const useCases = [{
  title: 'Software vendors (SaaS)',
  description: 'Sell accounting practice management software, tax tools, or cybersecurity solutions directly to managing partners of CPA firms and tax preparers in Manhattan using our accounting email list.',
  quote: 'The New York City accounting database coverage helped us reach 3x more qualified CPA prospects in the tri-state area than our previous provider.',
  author: 'Sarah K., VP of Sales'
}, {
  title: 'Financial services',
  description: 'Partner with bookkeepers and forensic accountants in Brooklyn and Queens for wealth management referrals, business lending, or specialized tax credit consulting.',
  quote: 'Direct access to New York City accounting firm owners and CFOs cut our sales cycle in half.',
  author: 'Michael R., Business Development'
}, {
  title: 'Marketing agencies',
  description: 'Pitch SEO, website redesign, and lead generation services to NYC tax preparers and audit specialists looking to grow their local client base in a competitive market.',
  quote: 'We can now target accounting firms by specialization and borough with precision.',
  author: 'Elena T., Agency Owner'
}, {
  title: 'B2B service providers',
  description: 'Offer recruiting, answering services, IT support, or office supplies to established CPA firms and bookkeepers across the New York metro area.',
  quote: 'The verified NYC email list quality is unmatched. Our bounce rate dropped to under 2%.',
  author: 'David L., Head of Growth'
}];
export function NYCAccountingUseCases() {
  return <section className="py-24 bg-white" data-id="element-180">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-183">
            Who buys our{' '}
            <span className="text-blue-600" data-id="element-184">
              NYC bookkeeper, CPA & accounting owner contacts?
            </span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-185">
            When you buy New York City accounting leads from Openmart, you get
            direct access to local business owners and decision-makers. Here's
            how our clients use the NYC accounting database.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-2" data-id="element-186">
          {useCases.map((useCase, index) => <motion.div key={useCase.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1],
          delay: index * 0.08
        }} className={`py-12 group ${index < 2 ? 'border-b border-slate-200' : ''}`} data-id="element-187">
              <div className="relative mb-6" data-id="element-188">
                <div className="text-7xl md:text-8xl font-bold text-blue-100 absolute -top-6 -left-3 z-0 select-none" data-id="element-189">
                  0{index + 1}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900 relative z-10 pt-4 md:pt-6" data-id="element-190">
                  {useCase.title}
                </h3>
              </div>
              <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-6" data-id="element-191">
                {useCase.description}
              </p>
              <div className="pl-5 border-l-2 border-blue-200" data-id="element-192">
                <p className="text-sm md:text-base text-slate-700 italic leading-relaxed mb-2" data-id="element-193">
                  "{useCase.quote}"
                </p>
                <p className="text-xs md:text-sm font-medium text-blue-600/70 uppercase tracking-wide" data-id="element-194">
                  {useCase.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}